'use client';

import { c as _c } from "react/compiler-runtime";
import { useI18n } from '@udemy-v2/i18n';
import { TextSkeleton } from '@udemy-v2/react-reveal-components';
import React from 'react';
import { BuyBox } from '@/features/course-landing-page/components/buy-box/buy-box.react-component';
import { useClpPurchaseContext, CLPPurchaseOption, useClpSelectedOption } from '@/features/course-landing-page/context/clp-purchase-context.react-component';
import { SubscriptionPurchaseContent } from '@/features/course-landing-page/components/subscription-purchase-content/subscription-purchase-content.react-component';
import styles from './marketplace-purchase-content.module.scss';
import { CourseContentPlacement } from '@/features/course-landing-page/course-landing-page.react-component';
export interface MarketplacePurchaseContentProps {
  placement: CourseContentPlacement;
  premiumCourseNotice?: React.ReactNode;
}

/**
 * This component renders the marketplace purchase options for subscription-eligible courses
 * @param placement
 * @param premiumCourseNotice
 * @constructor
 */
export const SubscriptionMarketplacePurchaseContent = t0 => {
  const $ = _c(19);
  const {
    placement,
    premiumCourseNotice
  } = t0;
  const {
    gettext
  } = useI18n();
  const {
    isLoading,
    isCourseInAvailablePlans
  } = useClpPurchaseContext();
  const {
    selectedPurchaseOption
  } = useClpSelectedOption();
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <TextSkeleton className={styles.skeleton} withTitle={true} lineCountPerParagraph={3} paragraphCount={2} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== gettext) {
      t2 = gettext("or");
      $[1] = gettext;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t2) {
      t3 = <div className={styles.separator}>{t2}</div>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <TextSkeleton className={styles.skeleton} withTitle={false} lineCountPerParagraph={2} paragraphCount={1} />;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t3) {
      t5 = <div className={styles.container}>{t1}{t3}{t4}</div>;
      $[6] = t3;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    return t5;
  }
  const isSubscriptionPrimary = selectedPurchaseOption === CLPPurchaseOption.SUBSCRIPTION;
  let t1;
  if ($[8] !== isCourseInAvailablePlans) {
    t1 = isCourseInAvailablePlans && <SubscriptionPurchaseContent />;
    $[8] = isCourseInAvailablePlans;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const subscriptionContent = t1;
  let t2;
  if ($[10] !== placement) {
    t2 = <BuyBox placement={placement} />;
    $[10] = placement;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const transactionalContent = t2;
  const primaryContent = isSubscriptionPrimary ? subscriptionContent : transactionalContent;
  const secondaryContent = isSubscriptionPrimary ? transactionalContent : subscriptionContent;
  const t3 = premiumCourseNotice && premiumCourseNotice;
  let t4;
  if ($[12] !== gettext || $[13] !== secondaryContent) {
    t4 = secondaryContent && <><div className={styles.separator}>{gettext("or")}</div>{secondaryContent}</>;
    $[12] = gettext;
    $[13] = secondaryContent;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== primaryContent || $[16] !== t3 || $[17] !== t4) {
    t5 = <div className={styles.container}>{t3}{primaryContent}{t4}</div>;
    $[15] = primaryContent;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};